import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { updateAskVyrillIntroModal } from "../../../Shared/PopUpModals/Actions";
import { updateAskVyrillModal } from "../Actions";
import { RootState } from "../AskVyrillReducer";

import AskVyrillModal from "./AskVyrillModal";
import AskVyrillIntro from "../../../Shared/PopUpModals/AskVyrillIntro/Index";
import "../styles/AskVyrillTopBar.scss";
import { updateNavStats } from "../../../Shared/SharedActions";
import { fetchNavbarStats } from "../../../vyrill-ui-config/layout/sidebar/navbarStatsActions";

const AskVyrillSection = ({ renderFrom, width }: any) => {
  const isModalOpen = useSelector(
    (state: RootState) => state.askVyrill.askVyrillModal.shouldOpen
  );

  const ask_vyrill_intro = useSelector(
    (state: any) => state.navbarStatsReducer.current_user.ask_vyrill_intro
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (ask_vyrill_intro) {
      dispatch(
        updateAskVyrillIntroModal({
          showIntro: ask_vyrill_intro,
        })
      );
    }
  }, []);

  const handleClose = () => {
    dispatch(
      updateAskVyrillIntroModal({
        showIntro: false,
      })
    );
    // API call to close the modal
    updateNavStats(false)
      .then((response) => {
        dispatch(fetchNavbarStats());
      })
      .catch((err) => {});
  };

  const activeReportTab = useSelector(
    (state: any) => state.sentimentReportReducer.activeReportTab
  );
  const isCampaignTab = useSelector(
    (state: any) => state.videoParams.isCampaignTab
  );

  return (
    <div className="AskVyrillTopBar" style={{ width: width }}>
      {!isModalOpen && (
        <div
          className="ask-vyrill-bar"
          style={
            {
              // width: activeReportTab || isCampaignTab ? "560px" : "700px",
              // width: "100%",
            }
          }
          onClick={() => {
            dispatch(
              updateAskVyrillModal({
                requestFrom: renderFrom,
                shouldOpen: true,
              })
            );
            handleClose();
          }}
        >
          <div className="ask-vyrill-title">Ask Vyrill</div>
          <div>
            <img
              src={
                require("@src/assets/images/logo/vyrill_new_logo.png").default
              }
              alt="logo"
              width="28"
            />
          </div>
        </div>
      )}
      <AskVyrillModal renderFrom={renderFrom} />
      <AskVyrillIntro />
    </div>
  );
};

export default AskVyrillSection;
